import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './suppressLegacyLibraryWarnings';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import App from './App';
import configStore from './store/configStore';

const initialState = {};
const store = configStore(initialState);

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
